import {callbackResponseMessages} from '@bpinc/adapters-public-api-types'

import type {CallbackMessageCallbacks} from './types'


export const createEmptyCallbackResponseCallbacksMap = (): CallbackMessageCallbacks => {
    return callbackResponseMessages.reduce<CallbackMessageCallbacks>((acc, messageType) => {
        acc[messageType] = {}
        return acc
    }, {})
}

export function getErrorMessage(err: unknown) {
    return err instanceof Error ? err.message : typeof err === 'string' ? err : undefined
}
